
class DGWHero extends HTMLElement {
    constructor() {
        super();

        this.interval = null;
        this.speed = 5;
        this.mobileSlides = 0;
        this.desktopSlides = 0;
        this.mobileActive = 0;
        this.desktopActive = 0;
        this.slides = null;
        this.slideArray = [];
        this.mobileSlideArray = [];
        this.dragState = null;
    }
    connectedCallback() {

        this.slides = this.querySelectorAll(".hero-slide");
        let current = this;

        this.checkSize();
        window.addEventListener("resize", () => {
            current.checkSize();
        });

        this.slides.forEach((slide) => {
            this.slideArray.push(slide);
            this.mobileSlideArray.push(slide);
            this.mobileSlides++;
            this.desktopSlides++;
            if (slide.classList.contains("dual")) {
                this.mobileSlides++;
                this.mobileSlideArray.push(slide);
            }
        });

        if (this.hasAttribute("data-speed")) {
            this.speed = this.getAttribute("data-speed");
        }

        if (this.mobileSlides > 0 && this.desktopSlides > 0) {
            this.setAttribute("data-mobile-active", this.mobileSlides);
            this.setAttribute("data-desktop-active", this.desktopSlides);
            this.mobileActive = 1;
            this.desktopActive = 1;
        }

        if (this.mobileSlides > 1) {
            let mobileControls = document.createElement("ul");
            mobileControls.classList.add("hero-controls");
            mobileControls.classList.add("mobile-controls");
            for (let i = 1; i <= this.mobileSlides; i++) {
                let li = document.createElement("li");
                let anchor = document.createElement("a");
                anchor.setAttribute("href", "#");
                anchor.innerText = i;
                anchor.setAttribute("data-slide", i);
                anchor.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    current.tock(true, i);
                    
                    
                    return false;
                });
                li.appendChild(anchor);
                mobileControls.appendChild(li);
            }
            this.appendChild(mobileControls);
        }
        this.setAttribute("data-mobile-active", this.mobileActive);

        if (this.desktopSlides > 1) {
            let desktopControls = document.createElement("ul");
            desktopControls.classList.add("hero-controls");
            desktopControls.classList.add("desktop-controls");
            for (let i = 1; i <= this.desktopSlides; i++) {
                let li = document.createElement("li");
                let anchor = document.createElement("a");
                anchor.setAttribute("href", "#");
                anchor.innerText = i;
                anchor.setAttribute("data-slide", i);
                anchor.setAttribute("data-slide", i);
                anchor.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    current.tock(false, i);
                    
                    
                    return false;
                });
                li.appendChild(anchor);
                desktopControls.appendChild(li);
            }
            this.appendChild(desktopControls);
        }
        this.setAttribute("data-desktop-active", this.desktopActive);

        function startHero() {
            current.setupInterval();
            window.removeEventListener("load", startHero, false);
        }

        window.addEventListener("load", startHero, false);

        this.addEventListener("touchstart", (e) => {
            current.startDrag(e);
        });
        this.addEventListener("touchmove", (e) => {
            current.drag(e);
        });
        this.addEventListener("touchend", (e) => {
            current.endDrag(e);
        });
    }

    setupInterval() {
        if (this.interval) {
            clearInterval(this.interval);
        }
        this.interval = setInterval(() => {
            this.tick();
        }, 1000 * this.speed);
    }

    disconnectedCallback() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    focusOnCurrent(isMobile) {
        // let activeSlide = (isMobile) ? this.mobileSlideArray[this.mobileActive - 1] : this.slideArray[this.desktopActive - 1];

        // if (activeSlide) {
        //     let button = activeSlide.querySelector("a");
        //     if (button) {
        //         button.focus();
        //     }
        // }
    }

    defaultDrag(e) {
        return {
            startX: e.clientX || e.touches[0].clientX,
            startY: e.clientY || e.touches[0].clientY,
            x: e.clientX || e.touches[0].clientX,
            y: e.clientY || e.touches[0].clientY
        };
    }

    startDrag(e) {
        this.dragState = this.defaultDrag(e);
    }

    drag(e) {
        this.dragState = (!this.dragState) ? this.defaultDrag(e) : this.dragState;
        
        this.dragState.x = e.clientX || e.touches[0].clientX;
        this.dragState.y = e.clientY || e.touches[0].clientY;
    }

    endDrag(e) {
        this.dragState = (!this.dragState) ? this.defaultDrag(e) : this.dragState;

        let xThreshold = window.innerWidth / 50;

        let isMobile = false;
        let mobileControls = this.querySelector(".mobile-controls");
        if (window.getComputedStyle(mobileControls).getPropertyValue("display") != "none") {
            isMobile = true;
        }

        this.dragState.endX = this.dragState.x;
        this.dragState.endY = this.dragState.y;

        this.dragState.dx = this.dragState.startX - this.dragState.endX;
        this.dragState.dy = this.dragState.startY - this.dragState.endY;

        if (this.dragState.dx < (xThreshold * -1)) {
            if (isMobile) {
                let newMobileLeft = ((this.mobileActive - 1) < 1) ? this.mobileSlides : this.mobileActive - 1;
                this.tock(true, newMobileLeft);
            } else {
                let newDesktopLeft = ((this.desktopActive - 1) < 1) ? this.desktopSlides : this.desktopActive - 1;
                this.tock(false, newDesktopLeft);
            }
        }
        if (this.dragState.dx > xThreshold) {
            if (isMobile) {
                let newMobileRight = ((this.mobileActive + 1) > this.mobileSlides) ? 1 : this.mobileActive + 1;
                this.tock(true, newMobileRight);
            } else {
                let newDesktopRight = ((this.desktopActive + 1) > this.desktopSlides) ? 1 : this.desktopActive + 1;
                this.tock(false, newDesktopRight);
            }
        }
        this.focusOnCurrent(true);
    }

    tock(isMobile, i) {
        this.setupInterval();
        if (isMobile) {
            this.mobileActive = i;
            this.checkDualOffset();
            this.setAttribute("data-mobile-active", this.mobileActive);
        } else {
            this.desktopActive = i;
            this.checkDualOffset();
            this.setAttribute("data-desktop-active", this.desktopActive);
        }
    }

    tick() {
        this.mobileActive++;
        this.desktopActive++;
        if (this.mobileActive > this.mobileSlides) {
            this.mobileActive = 1;
        }
        if (this.desktopActive > this.desktopSlides) {
            this.desktopActive = 1;
        }
        this.checkDualOffset();
        this.setAttribute("data-mobile-active", this.mobileActive);
        this.setAttribute("data-desktop-active", this.desktopActive);
    }

    checkDualOffset() {
        let index = 0;
        this.mobileSlideArray.forEach((slide) => {
            if (!slide.classList.contains("st")) {
                return;
            }
            //let prev = this.mobileSlideArray[index - 1];
            let next = this.mobileSlideArray[index + 1];
            let activeIndex = this.mobileActive - 1;
            let isIndexFirst = (slide == next);

            if (isIndexFirst && activeIndex > index) {
                slide.classList.add("shift");
            } else if (isIndexFirst && activeIndex <= index) {
                slide.classList.remove("shift");
            }

            index++;
        });
    }

    checkSize() {
        this.style.setProperty("--hero-width", this.offsetWidth + "px");
    }
}
  
customElements.define('dgw-hero', DGWHero);